"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = exports.topiaRichText = exports.topiaBlockClassnames = exports.useWindowDimensions = exports.formatCurrency = exports.getCurrencySymbol = void 0;
var react_1 = require("react");
var react_2 = require("@storyblok/react");
function getCurrencySymbol() {
    // @ts-ignore
    return (window || global).region === 'us' ? '$' : '£';
}
exports.getCurrencySymbol = getCurrencySymbol;
function formatCurrency(input, overrideRegion) {
    // @ts-ignore
    var region = overrideRegion || (window || global).region;
    if (input === undefined || input === null)
        return '';
    var currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    });
    var v = Number(input);
    return currencyFormatter.format(v);
}
exports.formatCurrency = formatCurrency;
function useWindowDimensions() {
    var _a = __read((0, react_1.useState)({
        width: undefined,
        height: undefined,
    }), 2), dimensions = _a[0], setDimensions = _a[1];
    (0, react_1.useLayoutEffect)(function () {
        function handleResize() {
            setDimensions({
                width: window.innerWidth || document.body.clientWidth,
                height: window.innerHeight || document.body.clientHeight,
            });
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return dimensions;
}
exports.useWindowDimensions = useWindowDimensions;
function optionalClassname(b, key, prefix) {
    var exists = b[key] !== undefined && b[key] !== null && b[key] !== '' && b[key] != '0';
    if (exists) {
        var isNegative = b[key][0] === '-';
        return "".concat(isNegative ? '-' : '').concat(prefix, "-").concat(b[key]);
    }
    return '';
}
function topiaBlockClassnames(blok) {
    var b = blok.topia_block || {};
    return [
        optionalClassname(b, 'textAlign', 'text'),
        optionalClassname(b, 'fontSize', 'text'),
        optionalClassname(b, 'textColor', 'text'),
        optionalClassname(b, 'marginTop', 'mt'),
        optionalClassname(b, 'marginBottom', 'mb'),
        optionalClassname(b, 'marginLeft', 'ml'),
        optionalClassname(b, 'marginRight', 'mr'),
        optionalClassname(b, 'background', 'bg'),
        optionalClassname(b, 'paddingTop', 'pt'),
        optionalClassname(b, 'paddingBottom', 'pb'),
        optionalClassname(b, 'paddingLeft', 'pl'),
        optionalClassname(b, 'paddingRight', 'pr'),
        optionalClassname(b, 'lg_marginTop', 'lg:mt'),
        optionalClassname(b, 'lg_marginBottom', 'lg:mb'),
        optionalClassname(b, 'lg_marginLeft', 'lg:ml'),
        optionalClassname(b, 'lg_marginRight', 'lg:mr'),
        optionalClassname(b, 'lg_background', 'lg:bg'),
        optionalClassname(b, 'lg_paddingTop', 'lg:pt'),
        optionalClassname(b, 'lg_paddingBottom', 'lg:pb'),
        optionalClassname(b, 'lg_paddingLeft', 'lg:pl'),
        optionalClassname(b, 'lg_paddingRight', 'lg:pr'),
        optionalClassname(b, 'alignItems', 'items'),
        optionalClassname(b, 'justifyContent', 'justify'),
        b.classNames,
    ].join(' ');
}
exports.topiaBlockClassnames = topiaBlockClassnames;
function topiaRichText(rt) {
    return (0, react_2.renderRichText)(rt);
    // return renderRichText(rt, {
    //   schema: {
    //     nodes: {
    //       ...RichTextSchema.nodes,
    //       bullet_list: (props: any) => (
    //         <ul className="list-inside list-disc">{props.children}</ul>
    //       ),
    //       paragraph: (props: any) => <p className="mb-4">{props.children}</p>,
    //     },
    //     marks: {
    //       ...RichTextSchema.marks,
    //     },
    //   },
    // })
}
exports.topiaRichText = topiaRichText;
function isValidEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}
exports.isValidEmail = isValidEmail;
